import IconMicrochipSolid from '@/assets/icons/font_awesome/microchip-solid.svg?react';
import IconRobotSolid from '@/assets/icons/font_awesome/robot-solid.svg?react';
import IconUsersSolid from '@/assets/icons/font_awesome/users-solid.svg?react';
import { useState } from 'react';
import { SidebarNavigationDesktop } from '../../pages/_base/sidebar_navigation/desktop/SidebarNavigationDesktop';
import { SidebarWrapper } from '../../pages/_base/SidebarWrapper';
import { TopbarInfoWrapper } from '../../pages/_base/TopbarInfoWrapper';
import { ButtonAdminTab } from './_base/ButtonAdminTab';
import { EAdminTab } from './_base/EAdminTab';
import { TabAdminWrapper } from './_base/TabAdminWrapper';
import { TabAdminDiffusionModelUD } from './diffusion_model_ud/TabAdminDiffusionModel';
import { TabAdminUsers } from './users/TabAdminUsers';
import { TabAdminVPS } from './vps/TabAdminVPS';

export function PageAdminViews() {
  const [currentTab, setCurrentTab] = useState(EAdminTab.USERS);

  //FIELDS
  /*
   * HTML
   */
  return (
    <>
      <div className="w-full h-full text-center flex-col">
        <div className="relative flex h-screen ">
          <SidebarNavigationDesktop />

          <SidebarWrapper>
            <TopbarInfoWrapper>
              <span className="w-full text-center">Admin</span>
            </TopbarInfoWrapper>
            <div className="flex flex-col gap-0 px-2 overflow-y-auto bg-component  pt-2">
              <ButtonAdminTab type={EAdminTab.USERS} Icon={IconUsersSolid} setCurrentTab={setCurrentTab} currentTab={currentTab} />
              <ButtonAdminTab type={EAdminTab.DIFFUSION_MODEL_UD} Icon={IconRobotSolid} setCurrentTab={setCurrentTab} currentTab={currentTab} />
              <ButtonAdminTab type={EAdminTab.DIFFUSION_MODEL_HUGGING_FACE} Icon={IconRobotSolid} setCurrentTab={setCurrentTab} currentTab={currentTab} />
              <ButtonAdminTab type={EAdminTab.VPS} Icon={IconMicrochipSolid} setCurrentTab={setCurrentTab} currentTab={currentTab} />
            </div>
          </SidebarWrapper>

          <TabAdminWrapper type={EAdminTab.USERS} currentTab={currentTab}>
            <TabAdminUsers />
          </TabAdminWrapper>

          <TabAdminWrapper type={EAdminTab.DIFFUSION_MODEL_UD} currentTab={currentTab}>
            <TabAdminDiffusionModelUD />
          </TabAdminWrapper>

          <TabAdminWrapper type={EAdminTab.VPS} currentTab={currentTab}>
            <TabAdminVPS />
          </TabAdminWrapper>
        </div>
      </div>
    </>
  );
}
